import React from "react";
import { TakeFivePage } from "./TakeFivePage";
import { takeFiveHomePage } from "./TakeFivePageSelector";
import './TakeFive.css'

export const TakeFiveHome = () => {
    return (
        <TakeFivePage selectedPage={takeFiveHomePage}>
            <div className="tf-list-container">
                <div className="take-five-home-header">
                    Home Safe Everyday
                </div>

                <div className="take-five-home-body">
                    The Take 5 is a task-based risk assessment tool used as a personnel risk assessment to get people
                    in the right mindset before completing a task. The process is a simple individual assessment to
                    understand the task, the potential hazards involved and the controls required to reduce or eliminate
                    risk.<br /><br />

                    <h2>The Take 5 follows these steps:</h2>

                    {'\u2022'}&nbsp; Think through the task<br />
                    {'\u2022'}&nbsp; Spot the hazards<br />
                    {'\u2022'}&nbsp; Asses the risks<br />
                    {'\u2022'}&nbsp; Make the changes<br />
                    {'\u2022'}&nbsp; Do the task safely<br /><br />
                    For more information contact: <span style={{ fontWeight: 'bold' }}>safeworking.specialist@bhp.com</span><br />
                </div>
            </div>
        </TakeFivePage>
    );
}